var map = {
	"./去除图像中人物的阴影.jpg": 7843,
	"./去除图像中人物的阴影结果图.jpg": 446,
	"./去除图像中的文字.jpg": 2225,
	"./去除图像中的文字结果图.jpg": 1184,
	"./去除图像红框中的人物.jpg": 8980,
	"./去除图像红框中的人物结果图.jpg": 3619,
	"./去除水印.jpg": 4249,
	"./去除水印结果图.jpg": 9432,
	"./去除红框中的文字.jpg": 3036,
	"./去除红框中的文字结果图.jpg": 827,
	"./将人物头发修改为白色，但保留原始光照效果.jpg": 2468,
	"./将人物头发修改为白色，但保留原始光照效果结果图.jpg": 8883,
	"./将光线更改为温暖的黄昏时分，但不要过于红，应该是偏黄.jpg": 1765,
	"./将光线更改为温暖的黄昏时分，但不要过于红，应该是偏黄结果图.jpg": 8732,
	"./将图像变为彩色.jpg": 4486,
	"./将图像变为彩色结果图.jpg": 2321,
	"./将夏天场景改为冬天，添加雪花.jpg": 8979,
	"./将夏天场景改为冬天，添加雪花结果图.jpg": 9774,
	"./将衣服修改为白色.jpg": 1160,
	"./将衣服修改为白色结果图.jpg": 5247,
	"./转为吉卜力风格.jpg": 688,
	"./转为吉卜力风格结果图.jpg": 6215,
	"./转为水彩风格.jpg": 8657,
	"./转为水彩风格结果图.jpg": 416
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7581;